import React, { Component } from 'react';
import Select from 'react-select';
import { withAuthorization } from '../Session';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';

import {TEAM_STATUS_OPTIONS, HACKATHON_EXP_OPTIONS, PRIMARY_SKILL_OPTIONS} from '../../constants/registration';


const CompetitorRegPage = () => (
  <div id="page-reg-competitor" className="reg-page">
    <CompetitorRegForm />
  </div>
);

const INITIAL_STATE = {
  hackathon_experience: '', main_skill: '', team_status: '', pref_role: {hacker:false, hipster:false, hustler:false},
  additional_skills: ''
};

class CompetitorRegFormBase extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  componentDidMount(){
    let uid = this.props.firebase.auth.currentUser.uid;
    this.props.firebase.user(uid).on("value", snapshot => {
      const userObject = snapshot.val();
      //console.log("COMPETITOR USER OBJ: ", userObject);
      if (userObject && userObject.competitor) {
        let {hackathon_experience, main_skill, team_status, pref_role, additional_skills} = userObject.competitor;
        this.setState({hackathon_experience, main_skill, team_status, additional_skills,
          pref_role: pref_role||{hacker:false, hipster:false, hustler:false}});
      }
    }, function (errorObject) {
      console.log("The read failed: " + errorObject.code);
    });
  }

  componentWillUnmount(){
    if(this.props.firebase.auth.currentUser && this.props.firebase.auth.currentUser.uid){
      //console.log("COMPETITOR UNMOUNT");
      this.props.firebase.user(this.props.firebase.auth.currentUser.uid).off();
    }
  }


  onSubmit = event => {
    const {hackathon_experience, main_skill, team_status, pref_role, additional_skills} = this.state;

    let comp_desc = {
      hackathon_experience, main_skill, team_status, pref_role, additional_skills,
      lastUpdated: Date.now()
    }
    //console.log("TODO: saving to the db", comp_desc);
    //update to database
    let uid = this.props.firebase.auth.currentUser.uid
    this.props.firebase.user(uid).update({competitor: comp_desc});
    // go to next page
    this.props.history.push(ROUTES.REG_DONE);

    event.preventDefault();
  }
  onBack = event => {
    this.props.history.push(ROUTES.REG_HOME)
  }

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  onTeamStatusSelect = selectedOption => {
    this.setState({ team_status: selectedOption });
  }
  setPrefRole = event => {
    this.setState({ pref_role: { ...this.state.pref_role, [event.target.name]: !this.state.pref_role[event.target.name]} });
  }
  onHackathonExp = selectedOptions => {
    this.setState({ hackathon_experience: selectedOptions });
  }
  onPrimarySkill = selectedOptions => {
    this.setState({ main_skill: selectedOptions });
  }

  validPrefRole = () =>{
    //valid pref role if at least one of the roles is selected
    let _validPrefRole = false;
    let _pref_role = this.state.pref_role;
    if(_pref_role){
      let {hacker, hipster, hustler} = _pref_role;
      if(hacker || hipster || hustler){
        _validPrefRole = true;
      }
    }
    return _validPrefRole;
  }

  render() {
    const {hackathon_experience, main_skill, team_status, pref_role, additional_skills,
      error} = this.state;

    let isInvalid = hackathon_experience === '' || main_skill === '' || team_status === '' || !this.validPrefRole();

    return (
      <div className="bound-box">
        <h1>Ready to hack?</h1>
        <p>Section 2 of 2</p>
        <form onSubmit={this.onSubmit}>
          <Select name="hackathon_experience" value={hackathon_experience} onChange={this.onHackathonExp} options={HACKATHON_EXP_OPTIONS} placeholder="What is your hackathon experience?*" />
          <br /><br />
          <Select name="main_skill" value={main_skill} onChange={this.onPrimarySkill} options={PRIMARY_SKILL_OPTIONS} placeholder="What is your primary skill?*" />
          <br /><br />
          <Select id="team_status" name="team_status" value={team_status} onChange={this.onTeamStatusSelect} options={TEAM_STATUS_OPTIONS} placeholder="What is your team status?*" />
          <p>Which competitor role(s) describe you best?* <br/><br/>
            <input type="checkbox" id="pref_role_hacker" name="hacker" value="HACKER" checked={(pref_role.hacker)} onChange={this.setPrefRole}/>
            <label htmlFor  ="pref_role_hacker"> <b>Hacker:</b> Technical and data skills</label>
            <br/>
            <input type="checkbox" id="pref_role_hipster" name="hipster" value="HIPSTER" checked={(pref_role.hipster)} onChange={this.setPrefRole}/>
            <label htmlFor="pref_role_hipster"> <b>Hipster:</b> Visionary and business oriented</label>
            <br/>
            <input type="checkbox" id="pref_role_hustler"name="hustler" value="HUSTLER" checked={(pref_role.hustler)} onChange={this.setPrefRole}/>
            <label htmlFor="pref_role_hustler"> <b>Hustler:</b> Presenter and salesperson</label>
            </p>
          <br />
          <textarea name="additional_skills" value={additional_skills} onChange={this.onChange} maxLength="300" rows="3"
            placeholder="Are there any other skills or achievements you would like to mention? (300 char limit)"/>
          <br />
          <button type="button" onClick={this.onBack}>Back</button>
          <button disabled={isInvalid} type="submit">Submit</button>
          {error && <p>{error.message}</p>}
        </form>
      </div>
    );
  }

}




const condition = authUser => !!authUser;


const CompetitorRegForm = compose(
  withRouter,
  withFirebase,
)(CompetitorRegFormBase);

export default withAuthorization(condition)(CompetitorRegPage);

export { CompetitorRegForm };